export class RenewErrorHandler {
    constructor(player, eventsManager) {
        this.player = player;
        this.eventsManager = eventsManager;
    }
    handleError(error) {
        console.warn(error);
        this.handleMessage(error.message);
        this.player.logout();
    }
    handleMessage(message) {
        if (message === "TIME_LIMIT_REACHED") {
            this.eventsManager.dispatchEvent("onTimeLimitReached", undefined, true);
        }
        else {
            this.player.showSessionExpired();
        }
    }
}
//# sourceMappingURL=RenewErrorHandler.js.map